module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAACXBIWXMAAAsSAAALEgHS3X78AAAATklEQVRIx+2UsQ3AIBDETJTB2Dxhg4zCBscOKfgCn3S1C0tuSTrwsH/jonDChW/dDUxgFLC/lkTn58E7kIK/Ohdu2227cNuuc+G2/VfbFyRjTkQyHwp3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos-icons/hamb.png
// module id = 701
// module chunks = 1